import React, { useCallback } from 'react';
import ListContainerView from './Switch/ListContainerView';

export default function ViewContainer({ view, items }) {
  const Switch = useCallback(() => {
    switch (view) {
      default:
      case 'list':
        return <ListContainerView items={items} />;
      case 'icon':
        return <></>;
    }
  }, [view, items]);

  return (
    <div className="pt-2">
      <Switch />
    </div>
  );
}
